import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Typography from '@mui/material/Typography'
import pepe1 from '../../assets/pepe/pepe1.jpg'
import pepe2 from '../../assets/pepe/pepe2.jpg'

// Easter egg: the original webplan's disclaimer, as a quiet line that opens an in memoriam
// for Pertti "Pepe" Teräväinen, who wrote it.
export default function PepeMemorial() {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  return (
    <>
      <Typography
        component="button"
        type="button"
        variant="caption"
        onClick={() => setOpen(true)}
        sx={{
          display: 'block',
          mx: 'auto',
          mt: 3,
          p: 1,
          border: 0,
          background: 'none',
          color: 'text.disabled',
          font: 'inherit',
          fontSize: '0.75rem',
          cursor: 'default',
        }}
      >
        {t('plan.links.disclaimer')}
      </Typography>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
        <DialogContent sx={{ textAlign: 'center' }}>
          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', mb: 2 }}>
            {[pepe1, pepe2].map((src) => (
              <Box
                key={src}
                component="img"
                src={src}
                alt=""
                sx={{ width: '50%', aspectRatio: '3 / 4', objectFit: 'cover', borderRadius: 1, filter: 'grayscale(1)' }}
              />
            ))}
          </Box>
          <Typography variant="overline" color="text.secondary">
            {t('plan.links.pepe.title')}
          </Typography>
          <Typography variant="h6">{t('plan.links.pepe.name')}</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {t('plan.links.pepe.body')}
          </Typography>
          <Typography variant="body2" sx={{ mt: 2, fontStyle: 'italic' }}>
            “{t('plan.links.disclaimer')}”
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>{t('plan.links.pepe.close')}</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
